import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

export const useTitleVisible = (selector: string) => {
  const { isInApp } = useAtomValue($UserAgent);

  useEffect(() => {
    if (!isInApp) {
      return;
    }

    let observer: null | IntersectionObserver = null;
    const titleElement = document.querySelector(selector);
    const docTitle = titleElement?.textContent || '';

    const main = async () => {
      const { setTitleVisible } = await import('@bridge/sharee');

      const handleIntersect = async (entries: any[]) => {
        entries.forEach(async (entry) => {
          if (entry.intersectionRatio > 0.0) {
            setTitleVisible({ title: '' });
          } else {
            setTitleVisible({ title: docTitle });
          }
        });
      };

      const createObserver = () => {
        const options = {
          threshold: 0.0,
        };
        const innerObserver = new IntersectionObserver(handleIntersect, options);
        if (titleElement) {
          innerObserver.observe(titleElement);
        }
        return innerObserver;
      };

      observer = createObserver();
    };

    main();

    return () => {
      observer && observer?.disconnect();
    };
  }, []);
};
